module.exports = __webpack_public_path__ + "static/media/colorado-article-image.7d13cbec.png";